import React from 'react';
import { Link } from 'react-router-dom';

import { Image } from 'antd';

const Header = () => {
  return (
    <header className='eduzz-ui-layout-topbar-header px-8 py-3'>
      <Link to='/'>
        <Image preview={false} height={32} alt='MyEduzz' src='https://cdn.eduzzcdn.com/topbar/myeduzz.svg' />
      </Link>
    </header>
  );
};

export default Header;
